import * as t from "io-ts";
import { makeMessage, version } from "./shared.js";
import { themePreProtocol } from "./pre-protocol.js";
export const areYouReady = makeMessage("glide:are-you-ready", t.type({ debug: t.boolean }));
export const ready = makeMessage("glide:ready", t.type({
    version
}));
export const state = t.record(t.string, t.unknown);
export const setState = makeMessage("glide:set-state", t.type({
    state
}));
export const triggerAction = makeMessage("glide:trigger-action", t.type({
    name: t.string
}));
export const setTheme = makeMessage("glide:set-theme", t.type({
    theme: themePreProtocol
}));
export const v1OutgoingMessages = t.union([setState, setTheme, areYouReady]);
export const v1IncomingMessages = t.union([ready, setState, triggerAction]);
export const V1 = {
    outgoing: v1OutgoingMessages,
    incoming: v1IncomingMessages
};
